module.exports = __webpack_public_path__ + "static/media/event_home_black.3e6c8b47.svg";